import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsSafetyRequirementType, PmsSafetyRequirementType } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsSafetyRequirementType>
    useData={usePmsSafetyRequirementType}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
